import { rfPartners } from '../../rf/iem.js';
import { rfConflicts, rfDevices } from '../../rf/plan.js';
import { defineRule } from '../rule.js';

/** W: wireless carriers too close, or an intermodulation product on a carrier (OIL-19). */
export const rfConflict = defineRule(
  'rf-conflict',
  'warning',
  { en: 'Frequency conflict', de: 'Frequenzkonflikt' },
  (data, emit) => {
    const linked = (a: string, b: string) =>
      rfPartners(data, data.items[a]!).some((p) => p.id === b);
    const tvChannels = data.meta.rfTvChannels ?? [];
    return rfConflicts(rfDevices(data), linked, { tvChannels }).map((c) =>
      emit(c.ids, { kind: c.kind, frequency: c.frequency }),
    );
  },
);
